import { Component, contentChildren, input } from "@angular/core";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";

@Component({
  selector: "snt-page-toolbar",
  template: "<div></div>",
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `,
  standalone: false
})
export class PageToolbarComponent {
  items = contentChildren<PageToolbarItemComponent>(PageToolbarItemComponent);
  customClass = input<string>("");
  alignItems = input<string>("items-center");
}
